import type { FaireProductEntity } from "../../entity_types/product";

export const p_mhczqyx4zh: FaireProductEntity = {
  token: "p_mhczqyx4zh",
  type: "product",
  name: "Organic Lounge Summer Sets for Babies & Kids (6M-6Y)",
  brandToken: "b_gm63vb47za",
  brandName: "Little Organic Co",
  imageUrl:
    "https://cdn.faire.com/fastly/dc71fd6087912515c9d48731945ab74ae7992e9918aa942e5069180674f27c60.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0c0c9f0ba07939cf09eefd7f3b578f9394e515b934d259a67226a245649507b3.png",
    "https://cdn.faire.com/fastly/8a1ab42bd16a3cd5b2a7adc93dc55afd1130ffc147f2ca9825e24e7ad804dd9b.png",
    "https://cdn.faire.com/fastly/32e583d1271552ae2cb86d1e05a22002f142a4f6f453e52e9afaf472e588749a.png",
  ],
  priceDollars: 18.5,
  description:
    "Organic Cotton Lounge Sets for Babies & Kids (6M-6Y)\nOversized sets\n\nKeep your little ones cozy and stylish with our organic cotton lounge sets! Designed for comfort and crafted with care, these sets are perfect for babies and kids aged 6 months to 6 years.\n\n🌟 Features:\n\nMade with 100% organic cotton for soft, breathable comfort.\nAvailable in 4 trendy prints: playful checks, sweet small florals, cheerful daisies, and fun emoji smiley faces.\nIdeal for lounging, playing, and everyday wear.\n💚 Why Choose Us?\nOur lounge sets combine modern, kid-friendly designs with sustainable materials to ensure your little ones stay comfortable while you shop guilt-free.\n\nChoose a set (or all four!) to bring some personality to their wardrobe!",
  tags: [],
  msrpDollars: 37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:27:08.375Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
